import { render, staticRenderFns } from "./passwordPolicies.vue?vue&type=template&id=1f5352b8&scoped=true"
import script from "./passwordPolicies.vue?vue&type=script&lang=js"
export * from "./passwordPolicies.vue?vue&type=script&lang=js"
import style0 from "./passwordPolicies.vue?vue&type=style&index=0&id=1f5352b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5352b8",
  null
  
)

export default component.exports